import { StructuredText } from "datocms-structured-text-utils"

import { FaqProps } from "../../../design-system/faq"
import { generateFaqSchema } from "../../../shared-components/faq-collection/faq-schema"
import { extractText } from "../../../utils/text-extraction"

type AccordionBlock = {
  __typename: "DatoCms_AccordionRecord"
  id: string
  title: string
  content: StructuredText
}

const isQuestion = (title: string): boolean => title.trim().endsWith("?")

function isAccordionBlock(node: unknown): node is AccordionBlock {
  return (
    typeof node === "object" &&
    node !== null &&
    "id" in node &&
    "title" in node &&
    "content" in node &&
    "__typename" in node &&
    (node as { __typename: string }).__typename === "DatoCms_AccordionRecord"
  )
}

function findAccordionBlocks(body: StructuredText): AccordionBlock[] {
  const blocks: AccordionBlock[] = []

  const traverse = (node: unknown): void => {
    if (!node) return

    if (Array.isArray(node)) {
      node.forEach(traverse)
      return
    }

    if (typeof node === "object" && node !== null) {
      if (isAccordionBlock(node)) {
        blocks.push(node)
      }
      Object.values(node).forEach(traverse)
    }
  }

  traverse(body)
  return blocks
}

export const generateBlogFaqSchema = (body: StructuredText) => {
  const accordionBlocks = findAccordionBlocks(body)

  const faqs: FaqProps[] = accordionBlocks
    .filter(accordion => isQuestion(accordion.title))
    .map(accordion => ({
      question: accordion.title,
      answer: extractText(accordion.content),
      id: accordion.id,
    }))

  if (faqs.length === 0) {
    return null
  }

  return generateFaqSchema(faqs)
}
